var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaratDownGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5l5.696-5.45a.9.9 0 00-1.244-1.3L6.5 5.088 2.048.75a.9.9 0 10-1.244 1.3L6.5 7.5z",
    fill: "#006EAD"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02LjUwMDA4IDcuNUwxMi4xOTU3IDIuMDQ5NTlDMTIuNTU0OSAxLjcwNjAyIDEyLjU2NjkgMS4xMzcgMTIuMjIzOSAwLjc3NzgzN0MxMS44ODAzIDAuNDE4Njc1IDExLjMxMTMgMC40MDY2ODQgMTAuOTUyMSAwLjc0OTY1OEw2LjUwMDA4IDUuMDg3NjdMMi4wNDgwMyAwLjc0OTY1OEMxLjY4ODg3IDAuNDA2MDg1IDEuMTE5ODQgMC40MTg2NzUgMC43NzYyNjcgMC43Nzc4MzdDMC40MzI2OTQgMS4xMzY0IDAuNDQ1Mjg4IDEuNzA2MDIgMC44MDQ0NTEgMi4wNDk1OUw2LjUwMDA4IDcuNVoiIGZpbGw9IiMwMDZFQUQiLz4KPC9zdmc+Cg==";
export { SvgIconCaratDownGrey as ReactComponent };